import {
  IVirtualCatAsset,
  IVirtualCatLiteAsset,
} from "models/Assets/ICategoryAsset";

const defaultFields = [
  "id",
  "order",
  "icon_name",
  "reporting_name",
  "buyer_deeplink",
  "webview_link",
  "context",
];

const fields_ar = [
  ...defaultFields,
  "name_ar",
  "buyer_weblink_ar",
  "tag_label_ar",
];

const fields_en = [
  ...defaultFields,
  "name_en",
  "buyer_weblink_en",
  "tag_label_en",
];

const toLiteVirtualCat =
  (lang) =>
  (virtualCategory: IVirtualCatAsset): IVirtualCatLiteAsset => {
    const object = {};
    (lang === "en" ? fields_en : fields_ar).forEach((field) => {
      object[field] = virtualCategory[field] ?? null;
    });
    return object as IVirtualCatLiteAsset;
  };

export const toLiteVirtualCats =
  (lang) =>
  (virtualCategories: IVirtualCatAsset[]): IVirtualCatLiteAsset[] => {
    return virtualCategories.map(toLiteVirtualCat(lang));
  };